export default {
  LOAD_ALL_ACTIVITY_TYPES (state, payload) {
    state.activityTypes = payload
  },
  SET_CURRENT_ACTIVITY_TYPE (state, payload) {
    state.currentActivityType = payload
  },
  SET_CURRENT_ACTIVITY_TYPE_OBJ (state, payload) {
    state.currentActivityTypeObj = payload
  }
}
